import { Chip, FormHelperText, TextField } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Autocomplete from '@material-ui/lab/Autocomplete';
import React, { ChangeEvent } from 'react';
import { GenericFormItem } from 'skyone-lib/lib/GenericForm/interfaces';
import styles from './styles';

const useStyles = makeStyles(styles);
export interface Props {
  errors?: any;
  defaultValue: Array<{ value: string | number; label: string }>;
  setFieldValue: (field, value) => void;
}

const MultipleSelect = ({
  label,
  options,
  errors,
  stateKey,
  defaultValue,
  setFieldValue,
}: GenericFormItem & Props) => {
  const classes = useStyles();
  const [initialValues, setInitialValues] = React.useState<any[]>([]);
  const [selected, setSelected] = React.useState<any[]>([]);

  const handleChange = (event: ChangeEvent<{}>, value: any) => {
    setFieldValue(
      stateKey,
      value.map(item => item.value)
    );

    setSelected(value.map(item => item.value));
  };

  const filteredOptions = (values, arr) =>
    values?.filter(option => !arr.includes(option.value));

  React.useEffect(() => {
    setInitialValues(defaultValue);

    defaultValue.forEach(item => {
      setSelected(prev => [...prev, item.value]);
    });
  }, [defaultValue]);

  return (
    <>
      <Autocomplete
        multiple
        data-testid={'autosky-multipleselect'}
        options={filteredOptions(options, selected)}
        getOptionLabel={option => option.label}
        value={initialValues}
        renderInput={params => (
          <TextField
            {...params}
            variant="outlined"
            label={label}
            className={classes.autocomplete}
          />
        )}
        renderTags={(value: string[], getTagProps) =>
          value.map((option: any, index: number) => (
            <Chip
              key={option.label}
              variant="outlined"
              label={option.label}
              classes={{
                outlined: classes.chip,
                deleteIcon: classes.deleteIcon,
              }}
              {...getTagProps({ index })}
            />
          ))
        }
        onChange={handleChange}
      />
      {errors && errors[stateKey] && (
        <FormHelperText className={classes.error}>
          {errors[stateKey]}
        </FormHelperText>
      )}
    </>
  );
};

export default MultipleSelect;
